<template>
  <VueFinalModal
    v-model="show"
    classes="zoom-modal"
    content-class="zoom-modal__content"
    name="zoomModalIframe"
    @before-open="catchParams"
    @closed="close"
  >
    <template>
      <div class="zoom-modal__content__container">
        <div class="meetingSDKElement" ref="sdkEl">
        </div>
        <div class="zoom-modal__content__footer">
          <div>
            <div class="zoom-modal__content__footer__time">
              {{ time }}
            </div>
            <div class="zoom-modal__content__footer__title">
              {{ $localized(resource.localized_name, resource.name) }}
            </div>
          </div>
          <div v-if="resource.zoom_link" class="zoom_modal_trouble">
            <p v-text="$t('events.zoom.trouble')" /> <a :href="resource.zoom_link" target="_blank"
                                                        v-text="$t(isAuthor ? 'events.open-hours.start' : 'events.open-hours.join')" />
          </div>
        </div>
      </div>
    </template>
  </VueFinalModal>
</template>

<script>
import lz from 'lz-string'
import { VueFinalModal } from 'vue-final-modal'
import moment from 'moment-timezone'
import ZoomMtgEmbedded from '@zoom/meetingsdk/embedded'
import { KJUR } from 'jsrsasign'

const ZOOM_MEETING_SDK_KEY = process.env.VUE_APP_ZOOM_SDK_KEY; //'F5zogIUJQN2MiZcIK5tdNQ'
const ZOOM_MEETING_SDK_SECRET = process.env.VUE_APP_ZOOM_SDK_SECRET; //'ltOkb1A3YbKYVfy8nFYip3K0L5uhv73C'

console.log('ZOOM credentials: ', ZOOM_MEETING_SDK_KEY);
export default {
  name: 'ModalZoomIframe',
  components: { VueFinalModal },
  data() {
    return {
      show: false,
      resource: {},
      user: {},
      zoomParams: null,
      client: null,
    }
  },
  mounted() {
    window.onmessage = (e) => {
      if (e.data === 'user-leave') {
        this.close()
      }
    }
  },
  methods: {
    compress(obj) {
      return lz.compressToBase64(JSON.stringify(obj))
    },
    close() {
      console.log('close');
      this.client.leaveMeeting();
      ZoomMtgEmbedded.destroyClient();
      this.show = false
      this.resource = {}
      this.zoomParams = null
      this.client = null
    },
    async getSignature(role = 0) {
      const expirationSeconds = null//24h
      const iat = Math.floor(Date.now() / 1000)
      const exp = expirationSeconds ? iat + expirationSeconds : iat + 60 * 60 * 2
      const oHeader = { alg: 'HS256', typ: 'JWT' }

      const oPayload = {
        appKey: ZOOM_MEETING_SDK_KEY,
        sdkKey: ZOOM_MEETING_SDK_KEY,
        mn: +this.resource.zoom_meeting_number,
        role,
        iat,
        exp,
        tokenExp: exp,
      }

      const sHeader = JSON.stringify(oHeader)
      const sPayload = JSON.stringify(oPayload)
      return KJUR.jws.JWS.sign('HS256', sHeader, sPayload, ZOOM_MEETING_SDK_SECRET)
    },
    async catchParams(event) {
      this.user = await this.$auth.user()
      this.resource = event.ref.params.resource

      this.client = ZoomMtgEmbedded.createClient()
      await this.client.init({
        zoomAppRoot: this.$refs.sdkEl,
        language: this.currentLang,
        customize: {
          video: {
            isResizable: true,
            viewSizes: {
              default: { width: 400, height: 500 },
            },
          },
        },
      })

      await this.client.join({
          sdkKey: ZOOM_MEETING_SDK_KEY,
          signature: await this.getSignature(this.isAuthor ? 1 : 0),
          meetingNumber: +this.resource.zoom_meeting_number,
          password: this.resource.zoom_password,
          userName: `${this.$localized(this.user.localized_name, this.user.first_name)} ${this.$localized(this.user.localized_surname, this.user.last_name)}`,
          userEmail: this.user?.email,
        },
      )
    },
  },
  computed: {
    currentLang() {
      switch (this.$i18n.locale) {
        case 'ru':
          return 'ru-RU';
        case 'de':
          return 'de-DE';
        default:
          return 'en-US';
      }
    },
    isAuthor() {
      return this.resource.user?.id === this.user.id;
    },
    time() {
      const start = moment(this.resource?.time_start).format('HH:mm')
      const end = moment(this.resource?.time_finish).format('HH:mm')
      return `${start} - ${end}`
    },
  },
}
</script>

<style lang="scss">
.zoom-iframe {
  aspect-ratio: 16 / 9;
  width: 100%;
  height: 100%;
  max-height: calc(100dvh - 145px);
}

.zoom_modal_trouble {
  color: #A3A3A3;
  font-size: 14px;
  line-height: 130%;
  display: flex;
  align-items: center;

  p {
    max-width: 535px;
    margin-bottom: 0;
  }

  a {
    font-weight: 700;
    margin-left: 16px;
    background: #FFFFFF;
    border-radius: 5px;
    padding: 8px 12px;
    outline: none;
    text-decoration: none;
    color: #003882;
    min-width: 78px;
    text-align: center;
  }
}

.lang-trigger {
  width: 17px;
  height: 17px;
  background: #fff;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 10px;
  color: $darkGrey;
  text-transform: uppercase;
}

.lang-trigger-dropdown {
  display: grid;
  gap: 5px;

  &__option {
    display: flex;
    align-items: center;
    cursor: pointer;

    &__title {
      margin-left: 5px;
      text-transform: uppercase;
      font-style: normal;
      font-weight: 700;
      font-size: 12px;
      line-height: 147.5%;
      color: #474747;
    }
  }
}

.zoom-MuiPopper-root {
  z-index: 1001 !important;

  position: fixed !important;
  top: 10px !important;
  left: 10px !important;
  right: unset !important;
  transform: none !important;
}
.zoom-MuiPaper-root {
  width: 100% !important;
}

.zoom-modal {
  display: flex;
  padding: 24px 0;
  overflow-y: auto;

  &__content {
    width: 98%;
    border-radius: 13px;
    background: #1A1A1A;
    overflow: hidden;
    margin: auto;

    @include mobile {
      width: 100%;
    }

    &__container {
      display: flex;
      flex-direction: column;

      .meetingSDKElement {
        position: relative;
        z-index: 1000;

        > * {
          width: 100%;
        }
      }
    }

    &__footer {
      display: flex;
      align-items: center;
      flex: 0 1 auto;
      margin-top: auto;
      padding: 24px 42px 24px 24px;

      & > div:first-child {
        flex: 1;
      }

      &__time {
        font-weight: 400;
        font-size: 14px;
        line-height: 130%;
        color: #FFFFFF;
        margin-bottom: 2px;
      }

      &__title {
        font-weight: 700;
        font-size: 16px;
        line-height: 130%;
        color: #FFFFFF;
      }
    }
  }
}
</style>
